import React from "react";
import {
  Alert,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import {
  approveConsentRequest,
} from "../../api/requests";

import classes from "./SettingsConsent.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import Signature from "../../containers/FormBuilder/Signature/Signature";

class ConsentApproveForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  async componentDidMount() {}

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          await approveConsentRequest({
            consentID: this.props.id,
            approved_by_signature: values.approved_by_signature,
            password: values.password,
          });

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};

            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: [
                    new Error(
                      JSON.stringify(
                        get(e, `response.data.errors.${errorFieldKey}`)
                      )
                    ),
                  ],
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onCategoryChange = () => {
    this.props.form.setFieldsValue({ type: null });
  };

  render() {
    const { isLoading, requestResult, sites } = this.state;
    const {
      getFieldDecorator,
    } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t("Approve Consent")}
          </h4>

          <Row gutter={12}>
            <Col>
              <div>
                <b>{this.props.i18n.t("Signature")}</b>
                <Signature
                  fieldName="approved_by_signature"
                  form={this.props.form}
                  isRequired
                />
              </div>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col>
              <label>
                <Form.Item label={this.props.i18n.t("Password")}>
                  {getFieldDecorator("password", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(<Input type="password" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
              >
                {this.props.i18n.t("Approve consent")}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "ConsentApproveForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ConsentApproveForm))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsConsent/ConsentApproveForm.js